import index from "./ezam_jintonn_check.vue";
export default index;
